import {
    getPersonCookie,
    setPersonCookie,
    setVisitedSiteCookie,
    getVisitedSiteCookie,
} from '@clearscore/helpers.cookies';
import { getAnonymousId } from '@clearscore/helpers.segment';
import getUid from '@clearscore/helpers.uid';
import canUseDom from '@clearscore/helpers.can-use-dom';
import { selectors as routerSelectors } from '@clearscore/redux.router';
import { actions as identityActions } from '@clearscore/redux.identity';

import { urlContainsMarketingParams, getMarketingUrlParams } from './helpers';

// Get value from cookie or, if no person cookie is set, get anonymous segment ID which will
// later be mapped to the user when they log in
const getUserIdentifier = () => getPersonCookie() || getAnonymousId() || getUid();

export default ({ dispatch, getState }) => {
    const isFirstVisit = !getVisitedSiteCookie();
    const userIdentifier = getUserIdentifier();

    if (isFirstVisit) {
        dispatch(identityActions.firstTimeVisit());
    }

    // always set or overwrite the visited site cookie
    // extending by a year each time a user visits
    setVisitedSiteCookie(userIdentifier);
    setPersonCookie(userIdentifier);

    if (canUseDom()) {
        const queryParams = routerSelectors.getQueryParams(getState());
        if (urlContainsMarketingParams(queryParams)) {
            dispatch(
                identityActions.trackUserCameFromMarketingSource({
                    context: getMarketingUrlParams({ queryParams }),
                }),
            );
        }
    }

    return null;
};
